import React, { PureComponent } from 'react';
import { Field, reduxForm, change, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validate, renderSelectField, renderMaterialField, renderCleaveMaterialField, checkValidCountries, checkValidState, popularCountriesArr } from '../../../helpers/formHelper';
import { isoNameConvert } from '../../../helpers/locationHelper';
import { checkLockout } from '../../../helpers/utils';
import _filter from 'lodash/filter';
import _orderBy from 'lodash/orderBy';
import { POPULAR_COUNTRIES, FUSE_OPTIONS } from '../../../config';
import Fuse from 'fuse.js';


const submit = (values) => {
    //console.log("DISPATCHED FROM PAYMENT PROCESSING - ", values);
}


class PassengerDetailsItem extends PureComponent {


  constructor(props){
    super(props);
    this.state = {
      phoneDropdown:"",
      nationalityDropdown:"",
      stateDropdown:"",
      isPhoneOpen:false,
      isNationalityOpen:false,
      isStateOpen:false,
      phoneSearch:[],
      phoneSearchOriginal:[],
      nationalitySearch:[],
      nationalitySearchOriginal:[],
      stateSearch:[],
      stateSearchOriginal:[],
      phoneDropdownNumber:-1,
      nationalityDropdownNumber:-1,
      stateDropdownNumber:-1
    }
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onDropdownClick = this.onDropdownClick.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onNationalityChange = this.onNationalityChange.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
    this.onSelectMobile = this.onSelectMobile.bind(this);
    this.fuseNationality = null;
    this.fuseState = null;
    this.fusePhone = null;
  }



  componentDidMount(){

    const { nationality, nationalityState } = this.props;

    document.body.addEventListener('click', this.documentClickHandler);


    //setup custom nationality flags
    this.setState({
      phoneSearch:nationality,
      phoneSearchOriginal:nationality,
      nationalitySearch:nationality,
      nationalitySearchOriginal:nationality,
      stateSearch:nationalityState,
      stateSearchOriginal:nationalityState
    }, () => {
        this.fusePhone = new Fuse(nationality, FUSE_OPTIONS);
        this.fuseNationality = new Fuse(nationality, FUSE_OPTIONS);
        this.fuseState = new Fuse(nationalityState, FUSE_OPTIONS);
    });


     //Populate nationality/state/phone
    setTimeout(() => {
      if(this.props.nationality.length > 0 || this.props.nationalityState.length > 0){
        this.populatePaxDetails(this.props.paxDetailsValues, this.props.nationality, this.props.nationalityState);
      }
    },400);


  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
    this.fuseNationality = null;
    this.fuseState = null;
    this.fusePhone = null;
    this.setState({
      phoneSearch:[],
      phoneSearchOriginal:[],
      nationalitySearch:[],
      nationalitySearchOriginal:[],
      stateSearch:[],
      stateSearchOriginal:[]
    });
  }

  documentKeydownHandler(e){

    //Increment/Decrement dropdown cursor position
    const { isPhoneOpen, phoneDropdownNumber, isNationalityOpen, nationalityDropdownNumber, isStateOpen, stateDropdownNumber } = this.state;
    const phoneInput = document.querySelectorAll('.filterDropdown.basket ul.phone li');
    const nationalityInput = document.querySelectorAll('.filterDropdown.basket ul.countryState.nationality li');
    const stateInput = document.querySelectorAll('.filterDropdown.basket ul.countryState.state li');

    if(isPhoneOpen){
      if(e.key === 'ArrowDown' && phoneDropdownNumber < phoneInput.length - 1){
        this.setState({phoneDropdownNumber:phoneDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && phoneDropdownNumber > 0){
        this.setState({phoneDropdownNumber:phoneDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){
        if(phoneInput[phoneDropdownNumber] !== undefined){
          this.onPhoneChange(null, phoneInput[phoneDropdownNumber].dataset.countrycode, phoneInput[phoneDropdownNumber].dataset.dialingcode, false);
        }
      }
    }

    if(isNationalityOpen){
      if(e.key === 'ArrowDown' && nationalityDropdownNumber < nationalityInput.length - 1){
        this.setState({nationalityDropdownNumber:nationalityDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && nationalityDropdownNumber > 0){
        this.setState({nationalityDropdownNumber:nationalityDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){
        if(nationalityInput[nationalityDropdownNumber] !== undefined){
          this.onNationalityChange(null, nationalityInput[nationalityDropdownNumber].dataset.name, nationalityInput[nationalityDropdownNumber].dataset.countrycode, false);
        }
      }
    }

    if(isStateOpen){
      if(e.key === 'ArrowDown' && stateDropdownNumber < stateInput.length - 1){
        this.setState({stateDropdownNumber:stateDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && stateDropdownNumber > 0){
        this.setState({stateDropdownNumber:stateDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){
        if(stateInput[stateDropdownNumber] !== undefined){
          this.onStateChange(null, stateInput[stateDropdownNumber].dataset.name, stateInput[stateDropdownNumber].dataset.abbreviation, false);
        }
      }
    }

  }


  componentDidUpdate(prevProps, prevState){

    const { phoneDropdownNumber, nationalityDropdownNumber, stateDropdownNumber  } = this.state;
    const { nationality, nationalityState, paxDetailsValues } = this.props;

    if(window.innerWidth > 639){
      if(phoneDropdownNumber !== prevState.phoneDropdownNumber){

        const phoneInputContainer = document.querySelector('.filterDropdown.basket ul.phone');
        const phoneInput = document.querySelectorAll('.filterDropdown.basket ul.phone li');


        for(let i = 0; i < phoneInput.length; i++){
          phoneInput[i].classList.remove('hover');
        }


        if(phoneInput[phoneDropdownNumber].dataset.countrycode !== undefined){

          //hover state
          phoneInput[phoneDropdownNumber].classList.add('hover');

          //scroll container
          phoneInputContainer.scrollTop = phoneInput[phoneDropdownNumber].offsetTop;

        }

      }

      if(nationalityDropdownNumber !== prevState.nationalityDropdownNumber){

        const nationalityInputContainer = document.querySelector('.filterDropdown.basket ul.countryState.nationality');
        const nationalityInput = document.querySelectorAll('.filterDropdown.basket ul.countryState.nationality li');


        for(let j = 0; j < nationalityInput.length; j++){
          nationalityInput[j].classList.remove('hover');
        }

        if(nationalityInput[nationalityDropdownNumber].dataset.name !== undefined){

          //hover state
          nationalityInput[nationalityDropdownNumber].classList.add('hover');

          //scroll container
          nationalityInputContainer.scrollTop = nationalityInput[nationalityDropdownNumber].offsetTop;

        }

      }

      if(stateDropdownNumber !== prevState.stateDropdownNumber){
        const stateInputContainer = document.querySelector('.filterDropdown.basket ul.countryState.state');
        const stateInput = document.querySelectorAll('.filterDropdown.basket ul.countryState.state li');


        for(let k = 0; k < stateInput.length; k++){
          stateInput[k].classList.remove('hover');
        }

        if(stateInput[stateDropdownNumber].dataset.name !== undefined){

          //hover state
          stateInput[stateDropdownNumber].classList.add('hover');

          //scroll container
          stateInputContainer.scrollTop = stateInput[stateDropdownNumber].offsetTop;

        }
      }
    }

    //setup custom nationality flags
    if(nationality !== prevProps.nationality){
      this.setState({
        phoneSearch:nationality,
        phoneSearchOriginal:nationality,
        nationalitySearch:nationality,
        nationalitySearchOriginal:nationality
      }, () => {
        this.fusePhone = new Fuse(nationality, FUSE_OPTIONS);
        this.fuseNationality = new Fuse(nationality, FUSE_OPTIONS);
      });
    }


    if(nationalityState !== prevProps.nationalityState){
      this.setState({stateSearch:nationalityState, stateSearchOriginal: nationalityState}, () => {
        this.fuseState = new Fuse(nationalityState, FUSE_OPTIONS);
      });
    }

    //Populate nationality/state/phone
    if(nationality !== this.props.nationality && nationalityState !== this.state.nationalitySearch){
      this.populatePaxDetails(paxDetailsValues, nationality, nationalityState);
    }


  }


  populatePaxDetails(paxDetailsValues, nationality, nationalityState){

    //Populate nationality/state if exist in state
    if(paxDetailsValues && paxDetailsValues.nationality !== "") {
        if(window.innerWidth < 640){
          this.onSelectMobile("nationality");
        }else{

          this.onNationalityChange(null, isoNameConvert(paxDetailsValues.nationality, "nationality", nationality, null), paxDetailsValues.nationality);
        }
    }

    if(paxDetailsValues && paxDetailsValues.state !== "") {
      if(window.innerWidth < 640){
        this.onSelectMobile("state");
      }else{
        this.onStateChange(null, isoNameConvert(paxDetailsValues.state, "nationalityState", null, nationalityState), paxDetailsValues.state);
      }
    }

    if(paxDetailsValues && paxDetailsValues.phonePrefix !== "") {
      if(window.innerWidth < 640){
        this.onSelectMobile("phonePrefix");
      }else{
        this.onPhoneChange(null, paxDetailsValues.phonePrefix, isoNameConvert(paxDetailsValues.phonePrefix, "phonePrefix", nationality, null));
      }
    }

  }


  documentClickHandler(e){

    const {
      phoneDropdown, phoneSearchOriginal, phoneSearch,
      nationalityDropdown, nationalitySearchOriginal, nationalitySearch,
      stateDropdown, stateSearchOriginal, stateSearch
    } = this.state;

    try{
      if(window.innerWidth > 639){
        if( e.target.offsetParent.className !== "filterDropdown basket no-margin" && e.target.offsetParent.className !== "phone" && e.target.offsetParent.className !== "phone countryState nationality" && e.target.offsetParent.className !== "filterDropdown basket no-margin nationality" ){
          this.setState({
            isPhoneOpen:false,
            isNationalityOpen:false,
            isStateOpen:false,
            phoneSearch:(phoneDropdown === "" || checkValidCountries(nationalitySearchOriginal, phoneDropdown) ) ? phoneSearchOriginal : phoneSearch,
            nationalitySearch:(nationalityDropdown === "" || checkValidCountries(nationalitySearchOriginal, nationalityDropdown) ) ? nationalitySearchOriginal : nationalitySearch,
            stateSearch:(stateDropdown === "" || checkValidState(stateSearchOriginal, stateDropdown)) ? stateSearchOriginal : stateSearch
          }, () => {
            if(checkValidCountries(nationalitySearchOriginal, phoneDropdown)){
            const dividers =  document.querySelectorAll('.dividers');
              for(let i = 0; i < dividers.length; i++){
                dividers[i].classList.remove('hide');
              }
            }
          });

        }
      }
    }catch(e){}
  }
  onDropdownClick(e, dropName){
    e.preventDefault();

    switch (dropName) {
      case 'phone':
        this.setState({ isPhoneOpen:!this.state.isPhoneOpen });
        break;
      case 'nationality':
        this.setState({ isNationalityOpen:!this.state.isNationalityOpen });
        break;
      case 'state':
        this.setState({ isStateOpen:!this.state.isStateOpen });
        break;
      default:
    }
  }
  onPhoneChange(e, name, dialCode, isClose=false){
    if(name !== undefined){
      this.setState({phoneDropdown:dialCode, isPhoneOpen:isClose}, () => { this.props.change('phonePrefix', name) });
    }
  }
  onNationalityChange(e, name, countryCode, isClose){

    const stateDropdown = document.querySelector('.passenger-details-item .state .filterDropdown-btn');

    this.setState({nationalityDropdown:name, isNationalityOpen:isClose}, () => {
       this.props.change('nationality', countryCode);
      if(stateDropdown !== null){
       this.props.change('state', '');
       this.setState({stateDropdown:''});
      }
    });
  }
  onStateChange(e, name, abbreviation, isClose){
    if(name !== undefined){
      this.setState({stateDropdown:name, isStateOpen:isClose}, () => { this.props.change('state', abbreviation) });
    }
  }
  onInputChange(e, inputName){
    const dividers = document.querySelectorAll('.dividers');

    if(e.target.value === ""){

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.remove('hide');
      }

      switch (inputName) {
        case 'phone':
            this.setState({phoneDropdown:"", phoneSearch:this.state.phoneSearchOriginal});
          break;

        case 'nationality':
            this.setState({nationalityDropdown:"", nationalitySearch:this.state.nationalitySearchOriginal});
          break;

        case 'state':
            this.setState({stateDropdown:"", stateSearch:this.state.stateSearchOriginal});
          break;

        default:

      }

    }else{

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.add('hide');
      }

      switch (inputName) {
        case 'phone':
          this.setState({phoneDropdown:e.target.value, phoneSearch:this.fusePhone.search(e.target.value)});
        break;

        case 'nationality':
          this.setState({nationalityDropdown:e.target.value, nationalitySearch:this.fuseNationality.search(e.target.value)});
          break;

        case 'state':
          this.setState({stateDropdown:e.target.value, stateSearch:this.fuseState.search(e.target.value)});
          break;

        default:
      }

    }

  }


  onSelectMobile(selectName){

    const nationality = document.querySelector('.payment-select select[name="nationality"]');
    const state = document.querySelector('.payment-select select[name="state"]');
    const phonePrefix = document.querySelector('.payment-select select[name="phonePrefix"]');

    switch (selectName) {
     
      case 'nationality':
        if(nationality !== undefined) nationality.classList.add('active');
        break;

      case 'state':
          if(state !== null) state.classList.add('active');
        break;

      case 'phonePrefix':
        if(phonePrefix !== undefined) phonePrefix.classList.add('active');
        break;

      default:

    }
  }


  renderPrefixSelectMobile(){
    return(
    <Field name="phonePrefix" component={renderSelectField} classType="payment-select" label="" onChange={e => this.onSelectMobile('phonePrefix')}>
      <option value="" disabled>Dial Code</option>
      <option value="" disabled>----------</option>
        { popularCountriesArr(this.state.phoneSearch, POPULAR_COUNTRIES).map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code } disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name} ( ${item.dialing_code} )` : "----------------"}</option>)}
      <option value="" disabled>----------</option>
      {this.props.nationality.map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code }  disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name} ( ${item.dialing_code} )` : "----------------"} </option>)}
    </Field>
    )
  }
  renderPrefixSelect(){

    const { isPhoneOpen, phoneDropdown, phoneSearch } = this.state;

    return(
      <div className="filterDropdown basket no-margin phone">
        <div className="row">
          <div className="columns small-12 no-margin">
            <div className="columns small-12 no-margin no-padding">
              <input type="text" placeholder="Dial code" onClick={ e => this.onDropdownClick(e, 'phone') } onKeyDown={e => this.documentKeydownHandler(e)} onChange={ e => this.onInputChange(e,'phone') } value={phoneDropdown} className={`filterDropdown-btn phone ${isPhoneOpen ? 'active' : ''} `} />
              <i className={`fa fa-chevron-down phone ${isPhoneOpen ? 'active' : ''}`} aria-hidden="true"></i>
            </div>
          </div>
           <div className="columns small-12 no-margin phone-container">
            <ul className="phone" style={{display: isPhoneOpen ? 'block':'none' }} >
              <li className="dividers" data-index="0">--------------------</li>
              {
                popularCountriesArr(phoneSearch, POPULAR_COUNTRIES).map((item, index) => {
                  return (
                    <li
                      data-index={index + 1}
                      data-countrycode={item.iso_country_code}
                      data-dialingcode={item.dialing_code}
                      onClick={e => this.onPhoneChange(e, item.iso_country_code, item.dialing_code)}
                      key={item.dialing_code + Math.random()}>
                      <img alt={`${item.name} flag`} src={`/images/flags/${item.iso_country_code.toLowerCase()}.png` } /> {item.name} ( {item.dialing_code} )
                    </li>
                  )
                })
              }
              <li className="dividers" data-index={POPULAR_COUNTRIES.length + 1}>--------------------</li>
              {

                  phoneSearch.map((item, index) => {
                    return (
                      <li
                        data-index={(POPULAR_COUNTRIES.length + 2) + index}
                        data-countrycode={item.iso_country_code}
                        data-dialingcode={item.dialing_code}
                        onClick={e => this.onPhoneChange(e, item.iso_country_code, item.dialing_code)}
                        key={item.dialing_code + Math.random()}>
                        <img alt={`${item.name} flag`} src={`/images/flags/${item.iso_country_code.toLowerCase()}.png` } />  {item.name} ( {item.dialing_code} )
                      </li>
                    )
                  })

              }
            </ul>
          </div>
        </div>
        <span className="form-error">Your prefix is required</span>
      </div>
    )
  }


  renderNationalitySelectMobile(){
    return(
      <Field name="nationality" component={renderSelectField} classType="payment-select" label="" onChange={e => this.onSelectMobile('nationality')}>
        <option value="" disabled>Select Nationality *</option>
        <option value="" disabled>----------</option>
          { popularCountriesArr(this.state.nationalitySearch, POPULAR_COUNTRIES).map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code } disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name}` : "----------------"}</option>)}
        <option value="" disabled>----------</option>
        {this.props.nationality.map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code }  disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name}` : "----------------"} </option>)}
      </Field>
    )
  }
  renderNationalitySelect(){

    const {isNationalityOpen, nationalitySearch, nationalityDropdown } = this.state;

    return(
      <div className="filterDropdown basket no-margin nationality">
        <div className="row">
          <div className="columns small-12 no-margin">
            <input type="text" placeholder="Select Nationality *" onClick={ e => this.onDropdownClick(e, 'nationality') } onKeyDown={e => this.documentKeydownHandler(e)} onChange={ e => this.onInputChange(e,'nationality') } value={nationalityDropdown} className={`filterDropdown-btn nationalityStateFuzzy ${isNationalityOpen ? 'active' : ''} `} />
            <i className={`fa fa-chevron-down phone ${isNationalityOpen ? 'active' : ''}`} aria-hidden="true"></i>
          </div>
           <div className="columns small-12 no-margin phone-container">
            <ul className="phone countryState nationality" style={{display: isNationalityOpen ? 'block':'none' }}>
              <li className="dividers" data-index="0">--------------------</li>
              {
                popularCountriesArr(nationalitySearch, POPULAR_COUNTRIES).map((item, index) => {
                  return (
                    <li
                      data-index={index + 1}
                      data-name={item.name}
                      data-countrycode={item.iso_country_code}
                      onClick={e => this.onNationalityChange(e, item.name, item.iso_country_code)}
                      key={item.dialing_code + Math.random()}>
                      {item.name}
                    </li>
                  )
                })
              }
              <li className="dividers" data-index={POPULAR_COUNTRIES.length + 1}>--------------------</li>
              {
                nationalitySearch.map((item, index) => {
                  return (
                    <li
                      data-index={(POPULAR_COUNTRIES.length + 2) + index}
                      data-name={item.name}
                      data-countrycode={item.iso_country_code}
                      onClick={e => this.onNationalityChange(e, item.name, item.iso_country_code)}
                      key={item.dialing_code + Math.random()}>
                      {item.name}
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
        <span className="form-error">Your nationality is required</span>
      </div>
    )
  }

  renderStateSelectMobile(countryCode){
      let searchCountry = "";
      if(countryCode === "US") searchCountry = "USA";
      if(countryCode === "CA") searchCountry = "Canada";

      if(countryCode === ""){
        return "";
      }else{
        return (
          <Field name="state" component={renderSelectField} classType="payment-select" label="" onChange={e => this.onSelectMobile('state')}>
            <option value="" disabled>Select State *</option>
             {_orderBy(_filter(this.props.nationalityState, ['country', searchCountry]), ['name']).map(item => <option key={item.name} value={item.abbreviation}>{item.name}</option>)}
           </Field>
        )
      }
  }
  renderStateSelect(countryCode){
    const { isStateOpen, stateDropdown, stateSearch } = this.state;
    let searchCountry = "";
    if(countryCode === "US") searchCountry = "USA";
    if(countryCode === "CA") searchCountry = "Canada";

    if(countryCode === ""){
      return "";
    }else{
      return (
        <div className="filterDropdown basket no-margin state">
          <div className="row">
            <div className="columns small-12 no-margin">
                <input type="text" placeholder="Select State *" onClick={ e => this.onDropdownClick(e, 'state') } onKeyDown={e => this.documentKeydownHandler(e)} onChange={ e => this.onInputChange(e,'state') } value={stateDropdown} className={`filterDropdown-btn nationalityStateFuzzy ${isStateOpen ? 'active' : ''} `} />
                <i className={`fa fa-chevron-down phone ${isStateOpen ? 'active' : ''}`} aria-hidden="true"></i>
            </div>
             <div className="columns small-12 no-margin phone-container">
              <ul className="phone countryState state" style={{display: isStateOpen ? 'block':'none' }}>
                {
                  _orderBy(_filter(stateSearch, ['country', searchCountry]), ['name']).map((item, index) => {
                    return (
                      <li
                        data-index={index}
                        data-name={item.name}
                        data-abbreviation={item.abbreviation}
                        key={item.name}
                        onClick={e => this.onStateChange(e, item.name, item.abbreviation)}>
                        {item.name}
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </div>
          <span className="form-error">Your state is required</span>
        </div>
      )
    }
  }

  renderPhone(bookingGroup){
    if(checkLockout(bookingGroup)){
      return <Field name="phoneLockout" fieldId="phone" component={renderMaterialField} type="text" label="Phone number *" />
    }else{
      return <Field name="phone" fieldId="phone" component={renderMaterialField} type="text" label="Phone number" />
    }
  }

  render(){
    const { handleSubmit, currentState, stateVisible, bookingGroup } = this.props;
  return (
    <form
      className="passenger-details-item"
      onSubmit={handleSubmit}>

<div className="row">
  <div className="column small-12">
    <h5 className="busabout-h5 orange-text">Add a lead Passenger</h5>
    <p>Please enter the passenger details below. Our age policy for passenger is older than 18 year old on date of travel. </p>
  </div>
</div>


<div className="row">
        <div className="column small-12 medium-6 col-left-mod">
          <Field name="firstName" fieldId="firstName" component={renderMaterialField} type="text" label="First Name *" />
        </div>

        <div className="column small-12 medium-6 col-right-mod">
          <Field name="surname" fieldId="surname" component={renderMaterialField} type="text" label="Surname *" />
        </div>
  </div>

  <div className="row">
        <div className="column small-12 medium-6 col-left-mod">
          <div className="column small-4 no-padding">
              {  (window.innerWidth < 640) ? this.renderPrefixSelectMobile() : this.renderPrefixSelect()  }
          </div>
          <div className="column small-8 no-padding">
            { this.renderPhone(bookingGroup) }
          </div>
        </div>

        <div className="column small-12 medium-6 col-right-mod">
          <Field name="email" fieldId="email" component={renderMaterialField} type="email" label="Email *" />
        </div>
  </div>

  <div className="row">
        <div className="column small-12 medium-6 large-4 col-3-mod-left">
            {  (window.innerWidth < 640) ? this.renderNationalitySelectMobile() :this.renderNationalitySelect()  }
        </div>

        <div className="column small-12 medium-6 large-4 col-3-mod-middle" style={{display:(stateVisible) ? "block": "none"}}>
          {  (window.innerWidth < 640) ?  this.renderStateSelectMobile(currentState) : this.renderStateSelect(currentState) }
        </div>

        <div className={`column small-12 medium-6 large-4 col-3-mod-middle ${(stateVisible) ? "state-active": ""}`}>
          <Field
            name="dob"
            fieldId="dob"
            component={renderCleaveMaterialField}
            type="text"
            label="Date of birth (DD/MM/YYYY) *"
            />
        </div>

        <div className={`column small-12 medium-6 large-4 col-3-mod-right end ${(stateVisible) ? "state-active": ""}`}>
          <div className="payment-select margin-b-15">
            <div className="gender-options">

              <div className="column small-6">
                <div className="radio">
                  <Field component="input" id="radio-1" name="sex" type="radio" value="male" />
                  <label htmlFor="radio-1" className="radio-label">Male</label>
                </div>
              </div>

              <div className="column small-6">
                <div className="radio">
                  <Field component="input" id="radio-2" name="sex" type="radio" value="female"/>
                  <label htmlFor="radio-2" className="radio-label">Female</label>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </form>
  )
  }
}


PassengerDetailsItem = reduxForm({
  form: 'PassengerDetails',
  destroyOnUnmount: false,
  validate,
  onSubmit:submit
})(PassengerDetailsItem);

function mapStateToProps(state){
  return{
    paxDetailsValues:getFormValues('PassengerDetails')(state),
    nationality:state.nationality,
    nationalityState:state.nationalityState,
    bookingGroup:state.bookingGroup.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    change
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengerDetailsItem);



// WEBPACK FOOTER //
// ./src/components/payment/components/passengerdetailsitem.js